import {
  IDX_LAUNCHLAB_PROGRAM_IDS,
  getIdxLaunchlabPlatformPda,
} from "@/config/idxLaunchlabAppConfig";

const cluster = process.env.NEXT_PUBLIC_CLUSTER?.trim() || "mainnet";

export function getLaunchlabCluster() {
  return cluster === "devnet" ? "devnet" : "mainnet";
}

export function getLaunchlabProgramId() {
  return getLaunchlabCluster() === "devnet"
    ? IDX_LAUNCHLAB_PROGRAM_IDS.devnet
    : IDX_LAUNCHLAB_PROGRAM_IDS.mainnet;
}

export function getLaunchMintApiBase() {
  return getLaunchlabCluster() === "devnet"
    ? "https://launch-mint-v1-devnet.raydium.io"
    : "https://launch-mint-v1.raydium.io";
}

export function getLaunchHistoryApiBase() {
  return getLaunchlabCluster() === "devnet"
    ? "https://launch-history-v1-devnet.raydium.io"
    : "https://launch-history-v1.raydium.io";
}

export function getIdxPlatformPda() {
  return getIdxLaunchlabPlatformPda();
}

export function isPlatformPdaConfigured() {
  return Boolean(getIdxPlatformPda());
}
